import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  appCommonCancel: {
    id: 'app.common.cancel',
  },
  deleteLocalDraft: {
    id: 'app.inventory.meters.deleteLocalDraft',
  },
  deleteLocalDraftConfirm: {
    id: 'app.inventory.meters.deleteLocalDraftConfirm',
  },
  deleteLocalRecord: {
    id: 'app.inventory.meters.deleteLocalRecord',
  },
  deleteLocalRecordConfirm: {
    id: 'app.inventory.meters.deleteLocalRecordConfirm',
  },
  scannerActionsUse: {
    id: 'app.inventory.scanner.actions.use',
  },
  scannerCandidateQrCode: {
    id: 'app.inventory.scanner.candidate.qrCode',
  },
  scannerCandidateText: {
    id: 'app.inventory.scanner.candidate.text',
  },
  scannerPhotoFilledValue: {
    id: 'app.inventory.scanner.photo.filledValue',
  },
  scannerPhotoCandidatesFoundOne: {
    id: 'app.inventory.scanner.photo.candidatesFound.one',
  },
  scannerPhotoCropHint: {
    id: 'app.inventory.scanner.photo.cropHint',
  },
  scannerPhotoCandidatesFoundOther: {
    id: 'app.inventory.scanner.photo.candidatesFound.other',
  },
  scannerPhotoNoUsableText: {
    id: 'app.inventory.scanner.photo.noUsableText',
  },
  scannerPhotoReadError: {
    id: 'app.inventory.scanner.photo.readError',
  },
  scannerPhotoReadFromPhoto: {
    id: 'app.inventory.scanner.photo.readFromPhoto',
  },
  scannerPhotoReadValue: {
    id: 'app.inventory.scanner.photo.readValue',
  },
  scannerPhotoSourceAlt: {
    id: 'app.inventory.scanner.photo.sourceAlt',
  },
  scannerValueCameraNotGranted: {
    id: 'app.inventory.scanner.value.cameraNotGranted',
  },
  scannerValueDescription: {
    id: 'app.inventory.scanner.value.description',
  },
  scannerValueTitle: {
    id: 'app.inventory.scanner.value.title',
  },
});
